import * as React from "react"

import { refinanceFlow } from "config/flow/refinance"
import Document from "components/Document"
import Flow from "components/Flow"
import Navbar from "components/Navbar"

export interface RefinanceProps {
  flowId: "refinance"
}

const Refinance: React.FC<RefinanceProps> = ({ flowId = "refinance" }) => {
  return (
    <Document
      brandMetaPrefix={true}
      title="Better"
      pageClass="bet-FlowPage"
      pageId="homepage"
    >
      <Navbar
        hideLinks={true}
        hideHamburger={true}
        hideSignIn={true}
        isFlow={true}
        startTransparent={true}
      />
      <Flow data={refinanceFlow} path={`/begin/${flowId}/`} />
    </Document>
  )
}

export default Refinance
